module.exports = __webpack_public_path__ + "img/safety-certificate.e742d05a.svg";